import ExhibitionEditForm from "./exhibition-edit-form";

const ExhibitionForms = {
  Edit: ExhibitionEditForm,
};

export default ExhibitionForms;
